import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import clsx from "clsx";

import { AppDispatch } from "../../../redux/reducer/store";
import {
  actionGetVacantRoutes,
  actionGetRoutesFilters,
  actionGetVacantRoutesNoModal,
} from "../../../redux/action/projects/actionRoutesNomodal";
import {
  reducerVacantRoutesInputValues,
  reducerSetVacantCheckboxes,
  reducerSetVacantListCheckboxes,
  reducerSetVacantListCheckboxesClear,
  reducerSetLimit,
} from "../../../redux/reducer/projects/reducers/reduserVacantRoutesListNoModal";
import Loader from "../../custom/loader/loader";
import Pagination from "../../pagination/pagination";
import LimitSelect from "../../custom/limitSelect/limitSelect";
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";

import {
  IRoutesOptions,
  IVacantRoutesNoModal,
} from "../../../types/routeInterfaces";

import "../table.scss";
import styles from "./recruiting.module.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableVacantRoutesListNotModal: FC<IVacantRoutesNoModal> = ({
  inVacancyPage,
  routes,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    data,
    routeList,
    limit,
    page,
    vacantRoutesInputValues,
    vacantCheckboxesNoModule,
    filters,
  } = useSelector((state: any) => state.projects.vacantRoutesNoModal);

  const { vacantRoutesSettings } = useSelector(
    (state: any) => state.projects.vacantRoutes
  );
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const { inputValues } = useSelector(
    (state: any) => state.recruiting.singleVacancy
  );
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [routesInPage, setRoutesInPage] = useState<IRoutesOptions[]>([]);
  const [isPending, setIsPending] = useState<boolean>(false);
  const iteral = data && inVacancyPage ? routesInPage : data;

  useEffect(() => {
    return () => {
      dispatch(reducerSetVacantListCheckboxesClear());
    };
  }, [dispatch]);
  // eslint-disable-next-line
  const actualLimit =
    JSON.parse(localStorage.getItem("pageLimit") as string) || limit;
  useEffect(() => {
    if (routes) {
      setIsPending(true);
      dispatch(actionGetVacantRoutes(limit, page)).then(() => {
        setIsPending(false);
      });
    }
    // eslint-disable-next-line
  }, [routes]);

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };
  const handleChange = (newLimit: number, newPage: number) => {
    setIsPending(true);
    dispatch(reducerSetLimit(newLimit));
    dispatch(actionGetVacantRoutes(newLimit, newPage)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem("pageLimit", JSON.stringify(newLimit));
  };
  // eslint-disable-next-line
  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };
  const handleCBrow = (route: IRoutesOptions) => {
    const updatedvacantCheckboxes = vacantCheckboxesNoModule.map(
      (item: IRoutesOptions) => {
        if (
          item.routeNo === route.routeNo &&
          item.project.id === route.project.id
        ) {
          return {
            ...item,
            checked: !item.checked,
          };
        } else {
          return item;
        }
      }
    );
    dispatch(reducerSetVacantCheckboxes(updatedvacantCheckboxes));
    dispatch(reducerSetVacantListCheckboxes(route));
  };
  useEffect(() => {
    if (iteral && routeList.data) {
      const data = routeList?.data.map((item: IRoutesOptions) => {
        return { ...item, checked: false };
      });
      dispatch(reducerSetVacantCheckboxes(data));
    }
    // eslint-disable-next-line
  }, [iteral, routeList, dispatch]);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = null;
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          ...(name === "routeNo" ? { [name]: [value] } : { [name]: value }),
        })
      );
    }
    setIsInputChange(true);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setIsPending(true);
      dispatch(actionGetVacantRoutesNoModal(limit, page)).then(() => {
        setIsPending(false);
      });
      setIsInputChange(false);
      resetPages();
    }
  };
  const handleFromFilter = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    const value = event.target.value;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = {
        ...vacantRoutesInputValues[name],
        from: null,
      };
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          [name]: { ...vacantRoutesInputValues[name], from: value },
        })
      );
    }
    setIsInputChange(true);
  };
  const handleToFilter = (
    event: React.ChangeEvent<HTMLInputElement>,
    name: string
  ) => {
    const value = event.target.value;
    if (value === "") {
      const updatedInputValues = { ...vacantRoutesInputValues };
      updatedInputValues[name] = { ...vacantRoutesInputValues[name], to: null };
      dispatch(reducerVacantRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerVacantRoutesInputValues({
          ...vacantRoutesInputValues,
          [name]: { ...vacantRoutesInputValues[name], to: value },
        })
      );
    }
    setIsInputChange(true);
  };
  useEffect(() => {
    if (inVacancyPage && data) {
      setRoutesInPage(data);
    }
  }, [data, inVacancyPage]);

  const getRowClassName = (route: IRoutesOptions) => {
    const statusObject = route?.routeStatusType;
    if (statusObject) {
      const statusKey = Object.keys(statusObject)[0];
      if (statusKey === "VacantNoVacancy") {
        return "red__row";
      } else if (statusKey === "ReplacementNoVacancy") {
        return "yellow__row";
      } else if (statusKey === "ActiveNoVacancy") {
        return "lightBlue__row";
      }
    }
    return "";
  };
  const renderVisibleRows = () => {
    const visibleRows: JSX.Element[] = [];
    for (let i = 0; i < iteral?.length; i++) {
      const route = iteral[i];
      if (route !== undefined) {
        visibleRows.push(
          <tr
            className={clsx("active__link_tr", getRowClassName(route))}
            key={`${i}+${route.routeNo}`}
          >
            <td>
              <input
                checked={route.checked}
                onChange={() => handleCBrow(route)}
                className="relative__elem"
                type="checkbox"
                disabled={
                  claims.includes("admin") ||
                  claims.includes("recruiting:vacancy:edit")
                    ? !inVacancyPage && !getRowClassName(route)
                    : true
                }
              />
            </td>

            {(claims.includes("admin") || claims.includes("projects:list")) &&
              vacantRoutesSettings.includes("project") && (
                <td style={{ minWidth: "180px" }}>
                  <span className="relative__elem">{route?.project.name}</span>
                </td>
              )}

            {vacantRoutesSettings.includes("routeNo") && (
              <td>
                <span className="relative__elem">{route.routeNo}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("login") && (
              <td>
                <span className="relative__elem">{route.login}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("routeType") && (
              <td style={{ minWidth: "180px" }}>
                <span className="relative__elem">
                  {route.routeStatusType &&
                    Object.values(route.routeStatusType).toString()}
                </span>
              </td>
            )}

            {vacantRoutesSettings.includes("vacancyName") && (
              <td>
                <span className="relative__elem">
                  <a
                    href={`/recruiting/vacancy/${route?.vacancy?.id}`}
                    className="report__link"
                  >
                    {route?.vacancy?.name}
                  </a>
                </span>
              </td>
            )}

            {vacantRoutesSettings.includes("vsv") && (
              <td style={{ minWidth: "280px" }}>
                <span className="relative__elem">{route.vsv}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("supervisor") && (
              <td style={{ minWidth: "280px" }}>
                <span className="relative__elem">{route.sv}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("tt") && (
              <td>
                <span className="relative__elem">{route.places}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("visitsOnWeek") && (
              <td>
                <span className="relative__elem">{route.visitsPlan}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("income") && (
              <td>
                <span className="relative__elem">{route.income}</span>
              </td>
            )}

            {vacantRoutesSettings.includes("plannedWage") && (
              <td>
                <span className="relative__elem">{route.plannedWage}</span>
              </td>
            )}
          </tr>
        );
      }
    }

    return visibleRows;
  };
  useEffect(() => {
    dispatch(actionGetRoutesFilters(inputValues.projects));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routes]);
  useEffect(() => {
    const handleDocumentClick = (
      event: React.ChangeEvent<HTMLInputElement> | Event
    ): void => {
      const inputEvent = event as React.ChangeEvent<HTMLInputElement>;
      const touchedInputs = ["posNum", "planVisits", "routeNo", "name"];
      if (!touchedInputs.includes(inputEvent.target.name) && isInputChange) {
        setIsPending(true);
        dispatch(actionGetVacantRoutesNoModal(limit, page)).then(() => {
          setIsPending(false);
        });
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener("click", handleDocumentClick);
      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener("click", handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);
  return (
    <>
      <div className="loader__wrapper">{isPending && <Loader />}</div>

      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        <div className="filters__container__mobile">
          {vacantRoutesSettings.includes("project") &&
            (claims.includes("admin") || claims.includes("projects:list")) && (
              <div className="filters__item__mobile">
                <div className="reports__region_block">
                  <CustomMultiSelect
                    setLoading={setIsPending}
                    reducer={reducerVacantRoutesInputValues}
                    inputValues={vacantRoutesInputValues}
                    action={actionGetVacantRoutesNoModal}
                    options={filters.project}
                    isShowPlaceholder={true}
                    resetPages={resetPages}
                    pageName="typeProject"
                    placeholder="Проект"
                    name="project"
                    limit={limit}
                    activeOptions={vacantRoutesInputValues.projects}
                  />
                </div>
              </div>
            )}

          {vacantRoutesSettings.includes("routeNo") && (
            <div className="filters__item__mobile">
              <div className="filter__number_block">
                <input
                  value={vacantRoutesInputValues.routeNo || ""}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  name="routeNo"
                  placeholder=" "
                  type="number"
                />
                <label>№</label>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("login") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutesNoModal}
                  options={filters.merch}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="typeProject"
                  placeholder="Логин/Локация"
                  name="merch"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("routeType") && (
            <div className="filters__item__mobile  filters__item__mobile--full">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutesNoModal}
                  options={filters.routeStatusType}
                  activeOptions={vacantRoutesInputValues.routeStatusType}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="type1"
                  placeholder="Тип маршрута"
                  name="routeStatusType"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("vacancyName") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className="filter__block">
                <input
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  autoComplete="off"
                  placeholder=" "
                  name="name"
                  type="text"
                />
                <label>Название вакансии</label>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("vsv") && (
            <div className="filters__item__mobile">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutesNoModal}
                  options={filters.vSupervisor}
                  isShowPlaceholder={true}
                  resetPages={resetPages}
                  pageName="type2"
                  placeholder="ВСВ"
                  name="vsv"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("supervisor") && (
            <div className="filters__item__mobile">
              <div className="routes__multiselect_block">
                <CustomMultiSelect
                  setLoading={setIsPending}
                  reducer={reducerVacantRoutesInputValues}
                  inputValues={vacantRoutesInputValues}
                  action={actionGetVacantRoutesNoModal}
                  isShowPlaceholder={true}
                  options={filters.supervisor}
                  resetPages={resetPages}
                  pageName="routes"
                  placeholder="Супервайзер"
                  name="sv"
                  limit={limit}
                />
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("tt") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>Кол-во ТТ на маршруте</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "posNum")}
                    onKeyPress={handleKeyPress}
                    name="posNum"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "posNum")}
                    onKeyPress={handleKeyPress}
                    name="posNum"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("visitsOnWeek") && (
           <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpan}>
                  Плановое кол-во визитов в неделю
                </span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "planVisits")}
                    onKeyPress={handleKeyPress}
                    name="planVisits"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "planVisits")}
                    onKeyPress={handleKeyPress}
                    name="planVisits"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("income") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpanFull}>Выручка</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "income")}
                    onKeyPress={handleKeyPress}
                    name="incomeFrom"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "income")}
                    onKeyPress={handleKeyPress}
                    name="incomeTo"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}

          {vacantRoutesSettings.includes("plannedWage") && (
            <div className="filters__item__mobile filters__item__mobile--full">
              <div className={styles.fromToFilter}>
                <span className={styles.widthSpanFull}>Зарплата</span>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleFromFilter(event, "wage")}
                    onKeyPress={handleKeyPress}
                    name="wageFrom"
                    placeholder=" "
                    type="number"
                  />
                  <label>От</label>
                </div>
                <div className={styles.filterNumberBlock + ' filter__number_block'}>
                  <input
                    onChange={(event) => handleToFilter(event, "wage")}
                    onKeyPress={handleKeyPress}
                    name="wageTo"
                    placeholder=" "
                    type="number"
                  />
                  <label>До</label>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={"table__wrapper"}>
          <table>
            <thead className="table__header table__header__filters">
              <tr>
                <th className="reports__checkbox_block"></th>

                {vacantRoutesSettings.includes("project") &&
                  (claims.includes("admin") ||
                    claims.includes("projects:list")) && (
                    <th>
                      <div className="reports__region_block">
                        <CustomMultiSelect
                          setLoading={setIsPending}
                          reducer={reducerVacantRoutesInputValues}
                          inputValues={vacantRoutesInputValues}
                          action={actionGetVacantRoutesNoModal}
                          options={filters.project}
                          isShowPlaceholder={true}
                          resetPages={resetPages}
                          pageName="typeProject"
                          placeholder="Проект"
                          name="project"
                          limit={limit}
                          activeOptions={vacantRoutesInputValues.projects}
                        />
                      </div>
                    </th>
                  )}

                {vacantRoutesSettings.includes("routeNo") && (
                  <th className="filter__number_block">
                    <div>
                      <input
                        value={vacantRoutesInputValues.routeNo || ""}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        name="routeNo"
                        placeholder=" "
                        type="number"
                      />
                      <label>№</label>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("login") && (
                  <th style={{ minWidth: "280px" }}>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutesNoModal}
                        options={filters.merch}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="typeProject"
                        placeholder="Логин/Локация"
                        name="merch"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("routeType") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutesNoModal}
                        options={filters.routeStatusType}
                        activeOptions={vacantRoutesInputValues.routeStatusType}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="type1"
                        placeholder="Тип маршрута"
                        name="routeStatusType"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("vacancyName") && (
                  <th style={{ minWidth: "180px" }}>
                    <div className="filter__block">
                      <input
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete="off"
                        placeholder=" "
                        name="name"
                        type="text"
                      />
                      <label>Название вакансии</label>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("vsv") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutesNoModal}
                        options={filters.vSupervisor}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName="type2"
                        placeholder="ВСВ"
                        name="vsv"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("supervisor") && (
                  <th>
                    <div className="routes__multiselect_block">
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerVacantRoutesInputValues}
                        inputValues={vacantRoutesInputValues}
                        action={actionGetVacantRoutesNoModal}
                        isShowPlaceholder={true}
                        options={filters.supervisor}
                        resetPages={resetPages}
                        pageName="routes"
                        placeholder="Супервайзер"
                        name="sv"
                        limit={limit}
                      />
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("tt") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Кол-во ТТ на маршруте
                      </span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "posNum")
                          }
                          onKeyPress={handleKeyPress}
                          name="posNum"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "posNum")}
                          onKeyPress={handleKeyPress}
                          name="posNum"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("visitsOnWeek") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Плановое кол-во визитов в неделю
                      </span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "planVisits")
                          }
                          onKeyPress={handleKeyPress}
                          name="planVisits"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleToFilter(event, "planVisits")
                          }
                          onKeyPress={handleKeyPress}
                          name="planVisits"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("income") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span>Выручка</span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) =>
                            handleFromFilter(event, "income")
                          }
                          onKeyPress={handleKeyPress}
                          name="incomeFrom"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "income")}
                          onKeyPress={handleKeyPress}
                          name="incomeTo"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}

                {vacantRoutesSettings.includes("plannedWage") && (
                  <th>
                    <div className={styles.fromToFilter}>
                      <span>Зарплата</span>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleFromFilter(event, "wage")}
                          onKeyPress={handleKeyPress}
                          name="wageFrom"
                          placeholder=" "
                          type="number"
                        />
                        <label>От</label>
                      </div>
                      <div className="filter__number_block">
                        <input
                          onChange={(event) => handleToFilter(event, "wage")}
                          onKeyPress={handleKeyPress}
                          name="wageTo"
                          placeholder=" "
                          type="number"
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>{renderVisibleRows()}</tbody>
          </table>
          {(!routes || (data && data.length < 1)) && (
            <div className={styles.noData}>Нет данных</div>
          )}
        </div>

        <div className="pagination">
          <div className="pagination__count">Всего: {iteral?.length}</div>
          <div className="pagination__str">
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            count={iteral?.length}
            currentPage={currentPage}
            startPage={startPage}
            limit={actualLimit}
            pageName="userReports"
          />
        </div>
      </div>
    </>
  );
};

export default TableVacantRoutesListNotModal;
